















import { Component, Vue, Prop } from 'vue-property-decorator';
import { diffArrays, diffWords } from 'diff';

@Component({
  components: {},
})
export default class Diff extends Vue {
  @Prop({})
  private value!: string;
  @Prop()
  private expected!: string;
  @Prop({ default: true })
  private showAsList!: boolean;

  get parts() {
    const value = this.value;
    const expected = this.expected;

    if (this.showAsList) {
      return diffArrays(String(expected).split(','), String(value).split(','))
        .map(x => {
          return x.value.map(y => ({
            value: y,
            added: x.added,
            removed: x.removed,
          }));
        })
        .flat();
    } else if (String(expected).match(/^[\d,]+$/g)) {
      return [
        { value: String(value), added: true, removed: false },
        { value: ' expected ' + String(expected), removed: true, added: false },
      ];
    } else {
      return diffWords(String(expected), String(value));
    }
  }
}
